import React, {useContext} from 'react'

import ProgressContext from '../../progress-layout/progress-context'
import CompanyIntroduction from '../company-introduction'
import CompanyFinancials from '../company-financials'
import BuyerDetails from '../buyer-details'

const PreUnderwritingContent: React.FC = () => {
  const {currentStep} = useContext(ProgressContext)

  return (
    <>
      {currentStep === 1 && <CompanyIntroduction />}
      {currentStep === 2 && <CompanyFinancials />}
      {currentStep === 3 && <BuyerDetails />}
    </>
  )
}

export default PreUnderwritingContent
